import ivyImage1 from "./ivy (1).png";
import ivyImage2 from "./ivy (2).png";
import ivyImage3 from "./ivy (3).png";
import ivyImage4 from "./ivy (4).png";
import ivyImage5 from "./ivy (5).png";
import ivyImage6 from "./ivy (6).png";

const ivyimage = [
  ivyImage1,
  ivyImage2,
  ivyImage3,
  ivyImage4,
  ivyImage5,
  ivyImage6,
];

export default ivyimage;
